// l10n status: TODO
import { CreateComponent } from "components/utils/CreateComponent"
import { rootStore } from "store/RootStore"
import tvImg from "img/relatedContent/fallback_image_tv.png"
import seriesImg from "img/relatedContent/fallback_image_tv_series.png"
import serieLogo from "img/icons/series.svg"
import IconButton from "@mui/material/IconButton"
import { CALLING_CONTEXT_TYPE } from "store/page/OverlayEventDetails"
import { PROGRAM_DETAILS_MODE, PROGRAM_ORIGIN } from "scenes/components/EpgChannelDetailsInfo"
import { logResourceLoadFailure } from "utils/BugsnagReporter"
import { useState, useEffect, useRef, useLayoutEffect, useCallback } from "react"
import { observer } from "mobx-react"
import { debounce } from "lodash"
import { useMediaQuery } from "hooks/useMediaQyery"
import { screenInfo } from "utils/Utils"
import { isIpad, isAndroid } from "utils/Utils"
import { deepEqual } from "utils/CompareObjects"
import { analyticsScreen, analyticsMeta, analyticsProgramDetailsSource } from "store/qlapi/LogService"
import { DiscoverConst } from "./DiscoverConst"
import { bookmarkPercentage } from "utils/EventHelpers"
import { l10n } from "store/lang/L10n"

import "./HeroTile.css"

const IndicatorPills = observer(({ style, index, nbItems, origin, scrollIndex, isAnimating }) => {
	//console.debug("IndicatorPills", style, ix, nbItems)
	const pills = []
	for (let i = 0; i < nbItems; i++) {
		//console.debug("IndicatorPills", ix === i, ix, i)
		pills.push(false)
	}

	if (scrollIndex >= nbItems) console.warn("scrollIndex", scrollIndex)
	if (!isAnimating && scrollIndex < nbItems) {
		pills[scrollIndex] = true
	}

	useEffect(() => {

	}, [])

	return <div className={origin === PROGRAM_ORIGIN.discover ? "PaginationIndicatorsScrimmed" : "PaginationIndicatorsScrimmedCategory"} style={style}>
		<div className="IndicatorPills" style={{ width: nbItems * 12 + 16, height: 24, /*left: 0,*/ top: 0, position: 'absolute', background: 'rgba(0, 0, 0, 0.50)', borderRadius: 100 }} />
		<div className="PaginationIndicators" style={{ width: nbItems * 12 + 16 - 20, height: 8, top: 8, position: 'absolute' }}>
			{pills.map((item, idx) => (
				<div key={`p_${origin}` + idx} className="Ellipse1" style={{ width: 8, height: 8, left: idx * 12, top: 0, position: 'absolute', background: item ? '#EB003D' : 'rgba(255, 255, 255, 0.80)', borderRadius: 9999 }} />
			))}
		</div>
	</div>
})

let styleArray = { disover: null, overlay: null }
const minDetailsToTitleDistance = -1000 //20 disabled for the moment is it may cause layout bouncing
let keepDistance = minDetailsToTitleDistance
// TODO: check origin, callingContext, resetOverlay from callers
export const HeroTile = CreateComponent(null, false, true, ({ variant, isDragging, page, oEventData, item, ix, origin, forwardRef, nbItems, scrollIndex, isAnimating, callingContext = CALLING_CONTEXT_TYPE.keepOldContext, resetOverlay = () => { } }) => {
	let isMobile = useMediaQuery(`(max-width: ${DiscoverConst.mobileBreak}px)`)
	let isMedium = useMediaQuery(`(min-width: ${DiscoverConst.mobileBreak + 1}px) and (max-width: ${DiscoverConst.mediumBreak}px)`)
	//const isTablet = isIpad() || isAndroid()
	const isTablet = !isMobile && (isIpad() || isAndroid())

	const pageOverlay = rootStore.page.OverlayEventDetails
	const isModalOpen = pageOverlay.isShow || page.isShow
	const maxInlineTopRatio = origin === PROGRAM_ORIGIN.discover ? 0.52 : 0.4  // 0.52 : 0.42 // 0.38 is too small //0.50 : 0.4

	function getVisualHeight() {
		// https://journalctl.app/post/how-to-detect-and-handle-the-browser-address-bar-using-javascript
		// does not work on Android
		//const addressBarHeight = window.innerHeight - window.visualViewport?.height || 0
		let height = window.visualViewport.height

		if (isTablet && isAndroid()) {
			height -= 120 // addressBarHeight	// subtract approx. address bar height
		}
		return height
	}

	const cocoBookmarks = rootStore.page.CoCoBookmarks
	const cocoDiscover = rootStore.page.CoCoDiscover
	const [bookmarkProgress, setBookmarkProgress] = useState(null)
	const [innerDimensions, setInnerDimensions] = useState({ width: window.innerWidth, height: getVisualHeight() })

	// MTVW-933: specific classes for PROGRAM_ORIGIN.overlay
	if (!styleArray[origin]) styleArray[origin] = new Array(nbItems).fill(null)
	function calcStyle() {
		const aspectRatio = 16 / 9
		const verticalBorder = origin === PROGRAM_ORIGIN.discover ? isMobile ? 48 : isMedium ? 90 : 60 : 0
		const tileGap = 24
		const innerW = origin === PROGRAM_ORIGIN.overlay ? page.modalWidth : window.innerWidth
		//const horizontalBorder = isMobile ? 2 * 20 : isMedium ? 2 * 60 : 2 * 80
		// CHANGE for full width, set horizontalBorder = 0
		const horizontalBorder = 0
		const episodeTileWidth = 304
		const episodeTileHeight = 274
		const dummyCategoryLaneHeight = 256
		const categoriesSeparatorHeight = 120 + 10 // 10px bottom border
		let heroHeight = origin === PROGRAM_ORIGIN.discover ? getVisualHeight() - verticalBorder - 10 : page.modalHeight - verticalBorder - 10// 10px below HeroTile
		//console.debug("heroHeight", heroHeight, heroHeight * aspectRatio, innerW - horizontalBorder)
		if (heroHeight * aspectRatio > innerW - horizontalBorder) heroHeight = (innerW - horizontalBorder) / aspectRatio
		//console.debug("calcStyle=", heroHeight, screenInfo(), isTablet, innerDimensions)
		//
		// { width: heroHeight * aspectRatio, height: heroHeight }
		// { width: innerW, height: (innerW) / aspectRatio }
		let style = {
			style: isMobile ?
				{ width: innerW - horizontalBorder /*40*/, height: ((innerW - horizontalBorder) /*40*/) / aspectRatio } :
				isMedium ? { width: innerW - horizontalBorder, height: heroHeight /*(innerW - horizontalBorder) / aspectRatio*/ } :
					{ width: innerW - horizontalBorder, height: heroHeight /*(innerW - horizontalBorder) / aspectRatio *//*- verticalBorder*/ }
		}
		//console.debug("style.style.width", style.style.width, innerWidth, style)
		// in case there is no continue watching lane, we just take the next lane
		// for test purpose without real inlineLane set style.inlineLane below to null
		const lanes = origin === PROGRAM_ORIGIN.discover ? document.getElementsByClassName("DiscoverLane") : document.getElementsByClassName("CategoryLane")
		style.inlineLane = lanes?.[0]
		// MTVW-980: reset styles for proper display if number of lanes changes (when there was previously no continue_watching lane)
		if (origin === PROGRAM_ORIGIN.discover) {
			for (let i = 0; i < lanes.length; i++) {
				lanes[i].style.position = ""
				lanes[i].style.top = ""
			}
		}
		if (!style.inlineLane) {
			// if there is no lane available, add an empty one for proper sizing
			style.inlineLane = {
				offsetHeight: episodeTileHeight, offsetWidth: episodeTileWidth, style: { position: "", top: "0px" }
			}
			style.isRealLane = false
		}
		else style.isRealLane = true
		const heroShaderVertical = document.getElementsByClassName(origin === PROGRAM_ORIGIN.discover ? "HeroShaderVertical" : "HeroShaderVerticalCategory")
		const sectionTitles = origin === PROGRAM_ORIGIN.discover ? document.getElementsByClassName("SectionTitle") : document.getElementsByClassName("CategoryTitle")
		let sectionTitle = sectionTitles?.[0]
		//const sectionTitle = document.getElementById("sectionTitle")
		const detailsButtons = document.getElementsByClassName(origin === PROGRAM_ORIGIN.discover ? "DetailsButton" : "DetailsButtonCategory")
		let detailsButton = detailsButtons?.[ix]
		let sectionTitleRect = sectionTitle?.getBoundingClientRect()
		let detailsButtonRect = detailsButton?.getBoundingClientRect()
		//console.debug("detailsButton", origin, ix, detailsButton, detailsButtonRect, detailsButtons, detailsButtons.length)
		//let detailsToTitleDistance = heroHeight + verticalBorder
		//console.debug("sectionTitleTop", ix, sectionTitleRect?.top)
		if (!sectionTitleRect) return styleInfo
		let detailsToTitleDistance = 0
		if (detailsButtons && sectionTitle) {
			// handle current HeroTile first
			if (sectionTitles?.[0]) sectionTitle = sectionTitles?.[0]
			if (sectionTitle) sectionTitleRect = sectionTitle?.getBoundingClientRect()
			if (detailsButtons?.[ix]) detailsButton = detailsButtons?.[ix]
			if (detailsButton) detailsButtonRect = detailsButton?.getBoundingClientRect()
			// consider all details buttons since some titles could span multiple lines
			//console.debug("top", origin, sectionTitleRect?.top, sectionTitleRect, detailsButtonRect?.bottom, detailsButtonRect)
			if (sectionTitleRect?.top && detailsButtonRect?.bottom && sectionTitleRect?.top < heroHeight + verticalBorder) detailsToTitleDistance = sectionTitleRect?.top - detailsButtonRect?.bottom
			else {
				//console.debug("cp k1 ix=%s", ix, sectionTitleRect?.top, detailsButtonRect?.bottom)
				detailsToTitleDistance = minDetailsToTitleDistance //keepDistance
			}
			//detailsToTitleDistance = sectionTitleRect?.top && detailsButtonRect?.bottom ? sectionTitleRect?.top - detailsButtonRect?.bottom : keepDistance //minDetailsToTitleDistance
			//console.debug("check", ix, detailsToTitleDistance, sectionTitleRect?.top, detailsButtonRect?.bottom, detailsButtons[ix]?.getBoundingClientRect())

			// consider all details buttons since some titles could span multiple lines
			for (let i = 0; i < nbItems; i++) {
				if (sectionTitles?.[0]) sectionTitle = sectionTitles?.[0]
				if (sectionTitle) sectionTitleRect = sectionTitle?.getBoundingClientRect()
				if (detailsButtons?.[ix]) detailsButton = detailsButtons?.[ix]
				if (detailsButton) detailsButtonRect = detailsButton?.getBoundingClientRect()
				// consider all details buttons since some titles could span multiple lines
				if (sectionTitleRect?.top && detailsButtonRect?.bottom && sectionTitleRect?.top < heroHeight + verticalBorder) detailsToTitleDistance = sectionTitleRect?.top - detailsButtonRect?.bottom
				else {
					//console.debug("cp k2", sectionTitleRect?.top, detailsButtonRect?.bottom)
					detailsToTitleDistance = minDetailsToTitleDistance //keepDistance
				}
				//detailsToTitleDistance = sectionTitleRect?.top && detailsButtonRect?.bottom ? sectionTitleRect?.top - detailsButtonRect?.bottom : keepDistance //minDetailsToTitleDistance
				//console.debug("check", ix, detailsToTitleDistance, sectionTitleRect?.top, detailsButtonRect?.bottom, detailsButtons[ix]?.getBoundingClientRect())

				//style.sectionTitleTop = sectionTitleTop
			}
		}
		//console.debug("rects", style.inlineLane, detailsButton, detailsButtonRect?.bottom, sectionTitle, sectionTitleRect?.top, detailsToTitleDistance)

		const episodeTileRect = document.getElementsByClassName(origin === PROGRAM_ORIGIN.discover ? "episodeTile" : "episodeTileCategory")?.[0]?.getBoundingClientRect()
		const offsetHeight = origin == PROGRAM_ORIGIN.discover ? style.inlineLane.offsetHeight : episodeTileRect?.height ? episodeTileRect?.height + categoriesSeparatorHeight : dummyCategoryLaneHeight + categoriesSeparatorHeight//356 //+ 145
		const inlineLaneTop = style.inlineLane ? heroHeight - offsetHeight + verticalBorder : heroHeight + verticalBorder
		//console.debug("inlineLaneTop=", origin, episodeTileRect?.height, detailsToTitleDistance, inlineLaneTop, heroHeight, offsetHeight, verticalBorder, detailsToTitleDistance >= minDetailsToTitleDistance)
		const keepAspectRatio = false
		const widthExceeded = /*screen.width > 2560 ||*/ keepAspectRatio ? innerW - horizontalBorder > style.style.width : false

		// on mobile the layout is fixed, exclude also the medium resolution as it would generate some strange behaviour with inline lanes
		/*
		console.debug("cp1  dist %s %s, top %s, exc %s, dist %s, top %s, height %s", ix, detailsToTitleDistance >= minDetailsToTitleDistance, inlineLaneTop > (heroHeight + verticalBorder) * maxInlineTopRatio, widthExceeded,
			detailsToTitleDistance, inlineLaneTop, (heroHeight + verticalBorder) * maxInlineTopRatio)
		*/
		///console.debug("inlineLaneTop %s, height %s, ratio %s", inlineLaneTop, heroHeight + verticalBorder, inlineLaneTop / (heroHeight + verticalBorder), (heroHeight + verticalBorder) * maxInlineTopRatio, sectionTitleRect?.top, style.inlineLane.offsetHeight, style.inlineLane)
		if (!isMobile && !isMedium && detailsToTitleDistance >= minDetailsToTitleDistance && inlineLaneTop > /*sectionTitleRect?.top + 20*/ (heroHeight + verticalBorder) * maxInlineTopRatio && !widthExceeded) {
			///console.debug("NOT ELSE", ix, detailsToTitleDistance)
			style.detailsToTitleDistance = detailsToTitleDistance
			//console.debug("innerW - horizontalBorder) / heroHeight", (innerW - horizontalBorder) / heroHeight)
			if (!keepAspectRatio && detailsToTitleDistance >= minDetailsToTitleDistance && innerW - horizontalBorder > style.style.width) {
				// full width, but reduced height, thus aspect ratio is not 16/9 anymore
				//if ((innerW - horizontalBorder) / heroHeight < 14 / 9) style.style.width = innerW - horizontalBorder
				style.style.width = innerW - horizontalBorder
			}
			style.canFitInlineLane = true // layout with inline lane
			style.pillsContainerWidth = style.style.width
			style.style.position = "relative"
			const topOffset = origin === PROGRAM_ORIGIN.discover ? 0 : categoriesSeparatorHeight
			if (ix === scrollIndex) {
				page.setIsLaneOnHero(style.inlineLane !== null, origin)
				forwardRef.current = style.inlineLane ?
					{
						arrowTop: style.isRealLane ? (inlineLaneTop + topOffset) / 2 : heroHeight / 2,
						tileWidth: style.style.width,
						edgeShader: false,
					}
					:
					{
						arrowTop: heroHeight / 2, tileWidth: style.style.width,
						edgeShader: false,
					}
			}
			if (style.inlineLane) {
				style.inlineLane.style.position = "absolute"
				style.inlineLane.style.top = inlineLaneTop + "px"
			}
			if (heroShaderVertical) {
				const percentage = Math.trunc(100 * (heroHeight - episodeTileHeight) / heroHeight)
				for (let i = 0; i < heroShaderVertical.length; i++)
					//heroShaderVertical[i].style.background = `linear-gradient(to bottom, transparent 0%, transparent ${percentage - 6}%, rgba(26, 26, 26, 0) ${percentage - 6}%, rgba(26, 26, 26, 1.0) ${percentage + 6}%, #1F1C1C ${percentage + 6}%)`
					heroShaderVertical[i].style.background = `linear-gradient(to bottom, transparent 0%, transparent ${percentage - 6}%, rgba(26, 26, 26, 0) ${percentage - 6}%, rgba(26, 26, 26, 1.0) ${percentage + 6}%, #1A1A1A ${percentage + 6}%)`
				//heroShaderVertical[i].style.background = `linear-gradient(to bottom, transparent 0%, transparent ${percentage - 6}%, rgba(26, 26, 26, 0) ${percentage - 6}%, rgba(26, 26, 26, 1.0) ${percentage + 6}%, #1A1A11A ${percentage + 6}%)`
			}
			if (sectionTitle && style.isRealLane && ix === 0) {
				sectionTitle.style.marginTop = "0px"
				// MTVW-980: reset style for proper vertical gap if number of lanes changes (when there was previously no continue_watching lane)
				if (sectionTitles?.[2]) sectionTitles[2].style.marginTop = ""
			}
			page.setSectionTitleMarginLeft(isMobile ? 16 : isMedium ? 40 : 80, origin)
			page.setFirstTileMarginLeft(isMobile ? 16 : isMedium ? 40 : 80, origin)
			//console.debug("heigth", style.style.height)
		}
		else {
			///console.debug("ELSE", ix, detailsToTitleDistance)
			style.detailsToTitleDistance = detailsToTitleDistance
			style.canFitInlineLane = false
			style.pillsContainerWidth = innerW - horizontalBorder
			// CHANGE for full width, uncomment 2 lines below
			/**/
			if (isMobile) {
				style.style.width = innerW
				style.style.height = style.style.width / aspectRatio
			}
			/**/
			style.style.position = "unset"	// important, otherwise IndicatorPills are now shown below the hero tile
			if (ix === scrollIndex) {
				page.setIsLaneOnHero(false, origin)
				forwardRef.current = {
					arrowTop: heroHeight / 2,
					tileWidth: style.style.width,
					edgeShader: false,
				}
			}
			if (style.inlineLane && sectionTitle) {
				//style.inlineLane.style.position = ""
				// CHANGE for full width, reset position and top
				style.inlineLane.style.position = "relative"
				style.inlineLane.style.top = "0px"
				sectionTitle.style.marginTop = ""
				page.setSectionTitleMarginLeft(style.canFitInlineLane || isMobile ? 16 : 40, origin)
				page.setFirstTileMarginLeft(style.canFitInlineLane || isMobile ? 16 : 40, origin)
			}
			// make sure that IndicatorPills fit into the available window height
			if (!isMobile) {
				//console.debug("cond ", Math.abs(style.style.width - (innerW - horizontalBorder)), style.style.height >= heroHeight, style.style.height, heroHeight, style.style.width, innerW)
				if (Math.abs(style.style.width - (innerW - horizontalBorder)) < 1 && style.style.height >= heroHeight /*getVisualHeight() - verticalBorder - 10 - 40*/) {
					//console.debug("style.style.height", style.style.height, heroHeight, heroHeight * maxInlineTopRatio)
					// ?? + verticalBorder ??
					if (style.style.height > (heroHeight + verticalBorder) * maxInlineTopRatio) {
						//console.debug("style.style.height", style.style.height, heroHeight, getVisualHeight() - heroHeight)
						// check if we need space for the IndicatorPills below the carousel
						// ?? + 10 ??
						if (getVisualHeight() - heroHeight <= verticalBorder /*+ 10*/) style.style.height = heroHeight - 40
						style.style.width = style.style.height * aspectRatio
					}
				}
				else {
					//console.debug("else case 1", style)
					style.style.width = innerW - horizontalBorder
					style.style.height = style.style.width / aspectRatio
				}
			}
			if (widthExceeded || style.style.width < innerW - horizontalBorder && !isMobile) {
				//style.style.width = style.style.width / 2
				//style.style.height = style.style.height / 2
				// fit 2 visible tiles into the carousel
				style.style.width = (innerW - horizontalBorder) / 2 - tileGap / 2
				style.style.height = style.style.width / aspectRatio
				//forwardRef.current = { arrowTop: style.style.height / 2, tileWidth: style.style.width, edgeShader: false }
			}
			if (ix === scrollIndex) {
				page.setIsLaneOnHero(false, origin)
				forwardRef.current = {
					arrowTop: style.style.height / 2,
					tileWidth: style.style.width,
					edgeShader: false,
				}
			}
		}
		//console.debug("detailsToTitleDistance", detailsToTitleDistance, style.canFitInlineLane, style.isRealLane, style.inlineLane/*, styleInfo*/)

		const indicatorBottom = style.canFitInlineLane ? style.isRealLane ? origin === PROGRAM_ORIGIN.discover ? heroHeight - inlineLaneTop + 70 : heroHeight - inlineLaneTop - 10 : 10 : -30
		//if (origin === PROGRAM_ORIGIN.overlay) console.debug("indicatorBottom", ix, indicatorBottom, heroHeight, inlineLaneTop)
		style.indicatorStyle = {
			cursor: "default", display: "flex", justifyContent: "center", alignItems: "center", position: "absolute",
			width: style.pillsContainerWidth, height: 24, /*paddingTop: 30,*/
			/*, visibility: ix === 0 ? "visible" : "hidden"*/
			paddingTop: style.inlineLane ? "" : 30,
			bottom: indicatorBottom
			//bottom: style.style.height - heroHeight + 320
		}

		styleArray[origin][ix] = style
		let value = style
		if (ix === nbItems - 1) {
			for (let i = 0; i < nbItems; i++) {
				//console.debug("styleArray", i, styleArray?.[i], styleArray?.[i]?.style)
				if (styleArray[origin][i]?.canFitInlineLane /*=== false*/ !== style?.canFitInlineLane /*=== false*/
					//|| styleArray[origin][i]?.indicatorStyle.bottom > style.indicatorStyle.bottom
				) {
					keepDistance = styleArray[origin][i]?.detailsToTitleDistance
					value = styleArray[origin][i]
					style = value
				}
			}
			for (let i = 0; i < nbItems; i++) styleArray[origin][i] = value
		}
		//setStyleInfo(style)
		return value
	}
	//const calcStyle = debounce(calcStyleImpl, 200)
	//const calcStyle = useCallback(debounce(calcStyleImpl, 200), [])
	//const [styleInfo, setStyleInfo] = useState(calcStyle())
	const [styleInfo, setStyleInfo] = useState(null)
	const didMount = useRef(false)

	function handleResize(e) {
		e?.preventDefault()
		e?.stopPropagation()
		isMobile = window.innerWidth <= DiscoverConst.mobileBreak
		isMedium = window.innerWidth > DiscoverConst.mobileBreak && window.innerWidth <= DiscoverConst.mediumBreak
		// address bar hiding/showing on tablets (and phones) might change the inner width and cause layout changes in the HeroTile
		// Observed on Android tablet
		//if (ix === nbItems - 1) keepDistance = minDetailsToTitleDistance
		// MTVW-947: performance, disabled if overlay is shown
		const resizeDisabled = origin === PROGRAM_ORIGIN.discover ? rootStore.page.OverlayEventDetails.isShow || rootStore.page.Discover.isShow : false
		// below needs to be executed once on tablet
		if ((!isTablet || didMount.current) && !resizeDisabled)
			// timeout to assure proper getElementById and getElementsByClassName in calcStyle
			setTimeout(() => {
				setStyleInfo(calcStyle())
			}, 50)
	}

	useEffect(() => {
		handleResize()
		setTimeout(() => {
			// make sure the div class HeroShaderVerticalCategory is rendered if only the height is changed so that
			// getElementsByClassName("HeroShaderVerticalCategory") returns elements, otherwise the picture might
			// appear to dark
			handleResize()
		}, 50)
		// MTVW-980: page.liveEvent
	}, [page.liveEvent, page.modalWidth, page.modalHeight, rootStore.page.OverlayEventDetails.isShow, rootStore.page.Discover.isShow])

	//const updateRequest = debounce(value => {
	//const updateRequest = () => {
	function updateRequest() {
		// MTVW-947: performance, disabled if overlay is shown
		if (!rootStore.page.OverlayEventDetails.isShow) {
			const style = calcStyle()
			//if (style !== null && styleInfo !== null && !deepEqual(style, styleInfo)) setStyleInfo(style)
			const equal = deepEqual(style, styleInfo)
			if (/*ix === nbItems - 1 &&*/ !equal) { // with uncommented condition only 1 tile would appear on mobiles
				setStyleInfo(style)
			}
		}
	}//, 100)

	//const debounceUpdateRequest = useCallback(value => { updateRequest(value) }, [])
	//const debounceUpdateRequest = debounce(updateRequest, 100)

	// MTVW-947: useLayoutEffect -> useEffect, test to avoid occasional residual show frame on iPad when closing overlay with playing movie
	// Done now in handleResize
	/*
	useEffect(() => {
		// needed on tablet, otherwise heroes are not shown!
		if (didMount.current && isTablet && !rootStore.page.OverlayEventDetails.isShow) updateRequest()
	})
	*/


	function handleOrientationChange(e) {
		e?.preventDefault()
		e?.stopPropagation()
		window.scrollTo(0, 0)
		setTimeout(() => { // need delay for updating window
			isMobile = window.innerWidth <= DiscoverConst.mobileBreak
			isMedium = window.innerWidth > DiscoverConst.mobileBreak && window.innerWidth <= DiscoverConst.mediumBreak
			//setInnerDimensions({ width: window.innerWidth, height: getVisualHeight() })
			handleResize()
			keepDistance = minDetailsToTitleDistance
			//setStyleInfo(calcStyle())
		}, 100)
	}

	const [toggle, setToggle] = useState(true)
	const handleToggle = () => {
		setToggle(!toggle)
	}

	useEffect(() => {
		if (didMount.current) {
			//console.debug("didMount.current")
			handleResize()
		} else {
			didMount.current = true
		}
	}, [toggle])

	/*
	// MTVW-947: additional useEffect to avoid occasional residual show frame on iPad when closing overlay with playing movie
	// not necessary anymore with discover updates disabled in CoCoBookmarks.getBookmarksAsync while in overlay
	useEffect(() => {
		if (!rootStore.page.OverlayEventDetails.isShow) setStyleInfo(calcStyle())
	}, [rootStore.page.OverlayEventDetails.isShow])
	*/

	function refreshBookmark() {
		// no bookmark progress bar on hero tile
		return
		/*
		if (item.eventId) {
			// would use position and progress properties instead 
			cocoBookmarks.getBookmarkAsync(null, false, item.eventId).then((bm) => {
				if (bm) {
					rootStore.page.MsEpg.getEventDetailsAsync(item.eventId, EventDetailsMode.Lite).then((event) => {
						setBookmarkProgress(bookmarkPercentage(bm, event?.event))
					})
				}
				else setBookmarkProgress(null)
			})
		}
		*/
	}

	useEffect(() => {
		// maxWait (number): It is the maximum number of times, the function will be called after completion of this time.
		// for PRORAM_ORIGIN.overlay resizing is done via observable page.modalWidth / modalHeight
		if (origin === PROGRAM_ORIGIN.discover) window.addEventListener("resize", debounce(handleResize, 100, { maxWait: 1 }))
		//window.addEventListener("resize", handleResize)
		window.addEventListener("orientationchange", handleOrientationChange)
		handleToggle()
		refreshBookmark()
		keepDistance = minDetailsToTitleDistance
		//console.debug("useEffect", isModalOpen, page, origin)
		// discover page would scroll up when opening categories modal
		if (!isModalOpen) window.scrollTo(0, 0)
		// make sure to move continue watching into hero frame at loading
		// ??
		handleResize()
		return () => {
			if (origin === PROGRAM_ORIGIN.discover) window.removeEventListener("resize", debounce(handleResize, 100, { maxWait: 1 }))
			//window.removeEventListener("resize", handleResize, 100)
			window.removeEventListener("orientationchange", handleOrientationChange)
			didMount.current = false
		}
	}, [])

	useEffect(() => {
		if (!rootStore.page.OverlayEventDetails.isShow) refreshBookmark()
	}, [cocoBookmarks.refreshCount])

	useEffect(() => {
		// relevant if the there was no continue watching lane and a new bookmark has been created within the discover page
		// in this case we have to restore the styles
		// MTVW-954: commented below condition
		//if (ix === 0) {
		const sectionTitle = document.getElementsByClassName("DiscoverLane")?.[1]
		if (sectionTitle) {
			sectionTitle.style.top = "unset"
			sectionTitle.style.position = "unset"
			///sectionTitle.style.marginTop = "60px"
		}
		//}
		// MTVW-954: for re-render
		handleResize()
	}, [cocoDiscover.lanesCount])

	const Poster = (item) => {
		return (item.pictureUri ? <img loading="lazy" className="episodeImage" src={item.pictureUri + "?mode=box&w=1920&h=1080"}
			// see https://www.afasterweb.com/2019/10/30/a-new-way-to-prevent-layout-jank-during-image-load/
			style={{ width: "100%", height: "auto" }} /> : <></>)
	}
	const Logo = (item) => {
		//console.debug("HeroLogo", item?.channelId, item?.channelLogoUri)
		// MTVW-1075
		return item?.channelLogoUri ? <img loading="lazy" className="Icon" style={{ width: 75, /*height: 40,*/ left: 12.89/*, top: 0, position: 'absolute'*//*, boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.50)'*/ }}
			src={item?.channelLogoUri + "?mode=box&w=480&h=270"} />
			: <></>
	}

	function clickHandler(e) {
		//console.debug("clickHandler", item)
		e.preventDefault()
		e.stopPropagation()
		const programDetails = origin === PROGRAM_ORIGIN.discover ?
			{ [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.discoverHero }
			: { [analyticsMeta.screen]: analyticsScreen.programDetails, source: analyticsProgramDetailsSource.discoverCategoryHero, category: rootStore.page.Discover?.discoverCategory?.topCategory?.id }
		if (item.eventId) {
			//console.debug("rootStore.page.Discover", rootStore.page.Discover.discoverCategory.topCategory.id)
			pageOverlay.setEpgEventById(item.eventId, false, { ignore: true }).then(res => {
				pageOverlay.setShow(false)
				//MTV-2808 if the player in overlay is playing it must be closed
				resetOverlay()
				//MTVW-490: added setComponentType
				// setShow first so that derived 'origin' is correct
				pageOverlay.setShow(true, callingContext)
				pageOverlay.setEpgEventById(item.eventId, false, programDetails).then(res => {
					pageOverlay.setComponentType('event')
				})
			})
		}
		else if (item.seriesId) {
			// launch search, see OverlayEventDetailsComponent
			/*
			if (pageOverlay.isVisible) {
				// MTVW-624: combined activityStack for related content and search
				pageOverlay.pushActivity({ type: 'related', id: oEventData?.id })
				//pageOverlay.pushActivity({ type: page.CATEGORY_SERIES, idSerie: page.id(item) })
			}
			*/
			// MTVW-965: TODO log also programDetails for series?
			rootStore.logService.analyticsScreenview(programDetails)
			pageOverlay.setComponentType(rootStore.page.Search.CATEGORY_SERIES).setSeriesId(item.seriesId)
				.setSeriesTitle(item.title).setShow(true, /*callingContext*/ CALLING_CONTEXT_TYPE.keepOldContext)
		}
	}

	function showPlayButton() {
		// no play button anymore
		//return !item.seriesId
		return false
	}

	return styleInfo && (
		<>
			<div key={`episode${origin}_${ix}_${page.liveEvent}`}>
				<div className={origin === PROGRAM_ORIGIN.discover ? "HeroTile" : "HeroCategory"} style={styleInfo.style} onClick={(e) => { if (!isDragging) clickHandler(e) }} >
					{/*
				<div className="Rectangle27" style={{ width: 480, height: 270, left: 0, top: 0, position: 'absolute', background: '#333333', borderRadius: 9.01 }} />
				<img loading="lazy" className="Image1" style={{ width: 480, height: 270, left: 0, top: 0, position: 'absolute' }} src="https://via.placeholder.com/480x270" />*/}
					<div className="HeroImageContainer"
					>
						{Poster(item)}
						{styleInfo.canFitInlineLane ?
							<>
								{styleInfo.isRealLane &&
									<div className={origin === PROGRAM_ORIGIN.discover ? "HeroShaderVertical" : "HeroShaderVerticalCategory"} />
								}
								<div className="HeroShaderHorizontal" />
							</>
							: <div className="HeroShader" />
						}
						{!styleInfo.canFitInlineLane /*|| !styleInfo.isRealLane*/ &&
							<>
								<div className="HeroChannelLogoShader" />
								<div className="HeroChannelLogo" style={{ position: "absolute", left: "unset", top: 16, right: 32 }}>
									{Logo(item)}
								</div>
							</>
						}
						{/*console.debug("HeroInfoContainer", ix, styleInfo.canFitInlineLane, styleInfo)*/}
						<div className="HeroInfoContainer" style={styleInfo.canFitInlineLane && styleInfo.inlineLane/*styleInfo.isRealLane*/ ? { top: 40, left: 80 } : {}}>
							<div className="HeroGenre">{item.displayText}</div>
							<div className="HeroTitle">{item.title}</div>
							{styleInfo.canFitInlineLane &&
								<>
									<div className="HeroChannelLogo" style={styleInfo.canFitInlineLane ? { paddingTop: 20 } : {}}>
										<div className="HeroChannelLogoShader">
											{Logo(item)}
										</div>
									</div>
									{styleInfo.inlineLane &&
										<div className={origin === PROGRAM_ORIGIN.discover ? "DetailsButton" : "DetailsButtonCategory"} onClick={(e) => { clickHandler(e) }} style={{ zIndex: 1, cursor: "pointer", width: 90, height: 40, marginTop: 20, paddingLeft: 16, paddingRight: 16, paddingTop: 8, paddingBottom: 8, left: 0, /*top: 190, position: 'absolute',*/ background: '#D40037', borderRadius: 8, justifyContent: 'center', alignItems: 'center', gap: 1, display: 'inline-flex' }}>
											<div className="Play" style={{ color: '#F3F3F3', fontSize: 18, fontFamily: 'EuropaBold', fontWeight: '700', wordWrap: 'break-word' }}>{l10n.featureDiscoverDetailsButton}</div>
										</div>
									}
								</>
							}
						</div>
					</div>
					{showPlayButton(item) && (
						<IconButton
							className="playButton"
							data-test="play_button_related_content"
							onClick={async (e) => {
								// MTVW-629: autoplay
								e.preventDefault()
								e.stopPropagation()
								//console.debug("rootStore.page.Player", rootStore.page.Player.player)
								rootStore.page.Player.player.setIsPosterVisible(true, "autoplay button", true)
								// necessary to move dialog on top
								//await pageOverlay.setEpgEventById(page.id(item), false, {})
								//pageOverlay.setShow(false)
								//MTV-2808 if the player in overlay is playing it must be closed
								// necessary to move dialog on top
								resetOverlay()
								// MTVW-629: hide overlay if liveTv
								// setShow first so that derived 'origin' is correct
								pageOverlay.setShow(!rootStore.page.Player.playerLiveTvVo.isPlayerActive, callingContext)
								await pageOverlay.setEpgEventById(item?.eventId, true)
								pageOverlay.setComponentType('event')
							}}
						>
						</IconButton>
					)}
				</div>
				{/* no bookmark progress bar on hero tile
				<div className="HeroProgressBarContainer" style={styleInfo.canFitInlineLane && bookmarkProgress !== null ? { height: 13, margin: "unset", width: "100%" } : {}}>
					{bookmarkProgress !== null &&
						<>
							<div className="HeroProgressBackground" />
							<div className="HeroProgress" style={{ width: bookmarkProgress + "%" }} />
						</>
					}
				</div>
				*/}
			</div>
			{ix === scrollIndex &&
				<IndicatorPills style={styleInfo.indicatorStyle}
					index={ix} nbItems={nbItems} origin={origin} scrollIndex={scrollIndex} isAnimating={isAnimating}
				/>
			}
		</>
	)
})
